import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Table, Typography } from 'antd';

import { columns } from './columns';
import { blacklistedStatuses } from '../../Constants';
import { addKey } from '../shared/utils';

const { Title } = Typography;

function buildHistoryRows(legacy, states) {
  if (Array.isArray(states) && states.length > 0) {
    return states
      .filter((s) => s && s.started && s.stateId)
      .map((s) => ({ stateId: s.stateId, started: s.started }));
  }
  if (Array.isArray(legacy) && legacy.length > 0) {
    return legacy
      .filter((s) => s && s.timeSentUTC && s.topic)
      .map((s) => ({ stateId: s.topic, started: s.timeSentUTC }));
  }
  return [];
}

const ShippingHistory = ({ data, loading }) => {
  const { history = [], historyStates = [] } = data;

  const adapted = buildHistoryRows(history, historyStates);

  const dataSource = [...adapted]
    .reverse()
    .filter((row) => !blacklistedStatuses.includes(row.stateId))
    .map(addKey);

  return (
    <>
      <Title level={3}>
        <FormattedMessage id="AboutDelivery.ShippingHistory" />
      </Title>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        showHeader={false}
        loading={loading}
        scroll={{ y: 350, x: 'max-content' }}
        style={{ marginBottom: 24 }}
      />
    </>
  );
};

export default ShippingHistory;
